var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--noto",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M119.7 102H8.3A4.2 4.2 0 0 1 4 97.8V30.3c0-2.4 2-4.4 4.4-4.4h111.2c2.4 0 4.4 2 4.4 4.4v67.4a4.4 4.4 0 0 1-4.4 4.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#66bb6a",
    d: "M119.8 90H8.2A4.2 4.2 0 0 1 4 85.6V30.3c0-2.4 2-4.4 4.4-4.4h111.2c2.5 0 4.4 2 4.4 4.4v55.4a4.2 4.2 0 0 1-4.2 4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.7 65.4c0-1.3-.5-2.3-1.3-3.1S36 60.7 34 60c-2.8-.9-5-2-6.2-3.4a7.5 7.5 0 0 1-2-5.4 7.7 7.7 0 0 1 7.2-7.9V40c0-.5.4-1 1-1h1c.6 0 1 .5 1 1v3.5c2.3.3 4 1.2 5.3 2.8a9.7 9.7 0 0 1 1.8 5.6c0 .5-.3.9-.8.9h-2a.8.8 0 0 1-.9-.8 6.5 6.5 0 0 0-1.3-3.7 4.4 4.4 0 0 0-3.6-1.7c-1.6 0-2.9.4-3.7 1.2a5 5 0 0 0-1.3 3.5c0 1.4.5 2.4 1.4 3.3.9.8 2.3 1.5 4.4 2.2a18 18 0 0 1 4.8 2.2 8 8 0 0 1 2.5 2.7 8 8 0 0 1 .8 3.8c0 2.2-.7 4-2 5.4a9 9 0 0 1-5.7 2.5v2.9c0 .5-.5.9-1 .9h-1.1a1 1 0 0 1-1-1v-2.8a8.6 8.6 0 0 1-5.8-2.7 8.5 8.5 0 0 1-2-5.4c-.1-.5.3-.9.7-.9h2.1c.5 0 .8.3.8.7.2 1.6.6 2.7 1.5 3.6 1 1 2.4 1.5 4.2 1.5 1.7 0 3-.4 4-1.2 1-1 1.6-2 1.6-3.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.6 74-3-.8.4-29.8v-1l3 1-.4 29.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.8,
    cy: 57.9,
    r: 18.5,
    fill: "#2e7d32",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M106.5 33.1c.8 5.4 5 9.7 10.5 10.5v28.6c-5.4.8-9.7 5.1-10.5 10.5h-85c-1.2-5-5.3-9-10.5-9.9V44.3c5.6-.9 10-5.5 10.6-11.2h84.8m1.9-2H19.7v.7c0 5.9-4.8 10.7-10.7 10.7v32.2c5.7 0 10.3 4.4 10.7 10h88.6c0-5.9 4.8-10.7 10.7-10.7V41.8c-6 0-10.7-4.8-10.7-10.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffecb3",
    d: "M53 26h22v76H53z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc06c",
    d: "M53 90h22v12H53z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.c94c02223291097631d0234089c09544.svg";
export { ForwardRef as ReactComponent };